'use client';
import React, { ChangeEvent } from 'react';

import classNames from 'classnames';
import currency from 'currency.js';

import styles from './selection-button.module.scss';

import { renderBadge, renderPrice } from './selection-button-util';

export interface SelectionButtonReqOptionalProps {
  uid: string;
  isDisabled?: boolean;
  name: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  checked: boolean;
  description: string;
  popular: boolean;
  price: number | currency;
  bullets: number;
}

export const SelectionButtonReqOptional = ({
  uid,
  onChange,
  name,
  description,
  checked,
  isDisabled,
  popular,
  bullets,
  price,
}: SelectionButtonReqOptionalProps) => (
  <div className={styles['button-container']}>
    <label
      className={`button-label`}
      data-testid="button-label-test"
      aria-label={name}
    >
      <input
        id={uid}
        onChange={onChange}
        data-testid={uid}
        disabled={isDisabled}
        className={isDisabled ? styles['button-disabled'] : styles['button']}
        type="radio"
        name={name}
        value={uid}
        checked={!isDisabled && checked}
        tabIndex={0}
      />
      <div
        className={styles['label-container']}
        data-testid="label-container-test"
      >
        <div className={styles['label-container-wrapper']}>
          {renderBadge(popular, false, false)}
          <div className={styles['description-container-no-image']}>
            <div
              className={styles['text-container']}
              data-testid="text-container-test"
            >
              <div className={styles['title-row-content']}>
                <div
                  className={classNames(styles['title'], 'body-extra-large')}
                >
                  {name}
                </div>
                {Array.from({ length: bullets }).map((_, index) => (
                  <span
                    key={bullets + `${index}`}
                    className={classNames(styles['bullet'], {
                      [styles['disabled']]: isDisabled,
                    })}
                  />
                ))}
              </div>
              <div className={styles['second-row-content']}>
                <div className={styles['description']} id="description">
                  <span
                    className={classNames('caption-regular')}
                    dangerouslySetInnerHTML={{
                      __html: description || '',
                    }}
                  />
                </div>
              </div>
            </div>
            {renderPrice(checked, price || 0)}
          </div>
        </div>
      </div>
    </label>
  </div>
);
